// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"iq-z","outfitFeedbackSection":"jq-z"};